import { includes, pathOr } from 'ramda'

export const getHasAdminRole = data => {
  const availableRoles = pathOr([], ['currentUser', 'availableRoles'], data)

  return includes('admin', availableRoles)
}
